import React from "react";
import { Behome } from "../features";

function BeHomeRequestedReservations() {
  return <Behome.RequestedReservations.Container />;
}

export default BeHomeRequestedReservations;
